import styled from 'styled-components';
import { Format, StyleColor } from '../../utils/styles-constants';
import { AuthenticateButton, blockButtonsStyle } from '../Authentication/styles';
import { Button } from '../Button/styles';

export const StyledMultiAppAuthentication = styled('div')`
	height: 100%;
	width: 100%;
	flex-flow: column nowrap;
	position: relative;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	background-color: ${StyleColor.White};
	overflow: auto;
`;

export const MultiAppAuthenticationWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const MultiAppAuthenticationContainer = styled('div')`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: auto;
	align-items: center;
	min-height: calc(100% - 60px);

	@media ${Format.SmallDesktop}, ${Format.MediumDesktop} {
		width: 900px;
	}
`;

export const FormWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	width: 300px;
	align-items: flex-start;
`;

export const WebpublicationLogo = styled('div')`
	display: flex;
	justify-content: center;
	width: 300px;
	padding-bottom: 40px;

	> svg {
		height: 70px;
		width: 240px;
	}

	@media ${Format.Smartphone} {
		width: 200px;

		> svg {
			height: 55px;
			width: 185px;
		}
	}
`;

export const MultiAppAuthenticationTitle = styled('div')`
	font-weight: 500;
	font-size: 20px;
	margin-bottom: 10px;
	text-align: left;
	width: 100%;
	height: 20px;

	@media ${Format.Smartphone} {
		height: 18px;
		font-size: 18px;
	}
`;

export const MultiAppAuthenticationError = styled('div')`
	color: ${StyleColor.Red};
	text-align: left;
	margin-bottom: 2px;
	font-size: 10px;
	letter-spacing: 0.4px;
`;

export const MultiAppAuthenticationOptionsWrapper = styled('div')`
	color: ${StyleColor.Grey600};
	display: flex;
	justify-content: space-between;
	flex-flow: column wrap;
	margin-top: 10px;
	align-items: flex-start;
`;

interface SubmitButtonProps {
	isLoginView: boolean;
}

export const SubmitButtonWrapper = styled('div')`
	text-align: right;
	margin-top: ${(props: SubmitButtonProps) => !props.isLoginView ? '27px' : '5px'};
	margin-bottom: 25px;
`;

export const InputWrapper = styled('div')`
	position: relative;

	input[type="checkbox"]{
		display : none;
	}

	> div:first-of-type {
		position: absolute;
		width: 15px;
		height: 15px;
		top: 0;
		left: 0;
		background: #eee;
		border: 1px solid #ddd;
		cursor: pointer;
	}

	div:first-of-type:after {
		content: '';
		position: absolute;
		width: 9px;
		height: 5px;
		background: transparent;
		top: 2px;
		left: 2px;
		border: 0;
		transform: rotate(-45deg);
	}

	input[type="checkbox"]:checked + div:first-of-type:after {
		border: 2px solid #333;
		border-top: none;
		border-right: none;
	}

	label {
		position: relative;
		margin-left: 25px;
		cursor: pointer;
	}
`;

export const ForgotPasswordLink = styled('a')`
	color: ${StyleColor.Blue500};
	text-decoration: none;
	font-size: 14px;
	margin-top: 25px;
`;

interface SwitchViewProps {
	isCreationView: boolean;
}

export const SwitchLoginViewBlock = styled('div')`
	cursor: pointer;
	text-align: left;
	color: ${StyleColor.Blue500};
	font-weight: 500;
	${(props: SwitchViewProps) => !props.isCreationView && 'margin-bottom: 25px;'}
`;

export const SwitchCompanyViewBlock = styled(SwitchLoginViewBlock)`
	padding-top: 15px;
	margin-bottom: 0;
	display: inline-block;
`;

export const SwitchToDemoViewBlock = styled('div')`
	/* Temporarily hide Demo button */
	display: none;
	width: 100%;
	max-width: 300px;
	padding: 5px;
	box-sizing: border-box;
	margin: 20px 0 30px 0;
	text-align: center;
`;

export const SwitchToDemoFormButton = styled(AuthenticateButton)`
	border-color: ${StyleColor.Blue800};
	background-color: ${StyleColor.Blue800};
	width: 100%;
	max-width: 100%;
	height: 45px;
	max-height: 45px;

	@media (hover: hover) {
		&:hover {
			border-color: ${StyleColor.Blue800};
			background-color: ${StyleColor.Blue800};
		}
	}
`;

export const BackLink = styled('div')`
	font-size: 14px;
	letter-spacing: 0.2px;
	height: 30px;

	> svg {
		width: 15px;
		height: 30px;
		position: relative;
		top: 10px;
		margin-right: 8px;
		fill: ${StyleColor.Blue500};
	}
`;

const buttonCommonStyle = `
	max-width: none;
	width: 100%;
	outline: none;
`;


export const MultiAppAuthenticationMethods = styled('div')`
	${blockButtonsStyle}
	margin-top: 20px;
`;

export const MultiAppAuthenticationMethodButton = styled(Button)`
	border-color: ${StyleColor.Grey300};
	background-color: ${StyleColor.White};
	color: ${StyleColor.Black};
	margin-bottom: 20px;
	border-radius: 3px;
	${buttonCommonStyle}
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/styles.ts